import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { lastValueFrom, Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { StripeCheckoutSession } from "@stripe/stripe-js";
import { Payment } from "../models/payment";

@Injectable({
  providedIn: "root"
})
export class PaymentsService {
  constructor(private http: HttpClient) { }

  async getMemberPayments(filters?: any): Promise<Payment[]> {
    let params: any = {};
    
    if (filters) {
      Object.keys(filters).forEach(key => {
        if (filters[key] != null && filters[key] !== '') {
          params[key] = filters[key];
        }
      });
    }

    return await lastValueFrom(this.http
      .get<Payment[]>(
        `${environment.apiUrl}/payments`,
        { params }
      ));
  }

  async getPaymentIntent(courseId: number, membername: string) {
    return await lastValueFrom(this.http
      .get(`${environment.apiUrl}/payments/intent/courses/${courseId}/regmembers/${membername}`));
  }

  /** Public lookup: recover the payment (incl. email) for a Stripe checkout session id. */
  async getPaymentBySessionId(sessionId: string): Promise<Payment> {
    return await lastValueFrom(this.http
      .get<Payment>(`${environment.apiUrl}/payments/sessions/${sessionId}`));
  }

  async createCheckoutSession(courseId: string, membername: string) {
    return await lastValueFrom(this.http.post<any>(`${environment.apiUrl}/payments/checkoutSession/courses/${courseId}/regmembers/${membername}`, {
      courseId,
      membername
    }));
  }

  async updatePaymentMemberCourse(paymentId: number, memberCourseId: number): Promise<Payment> {
    return await lastValueFrom(this.http.put<Payment>(
      `${environment.apiUrl}/payments/${paymentId}/memberCourse`,
      { memberCourseId }
    ));
  }

  async createPayment(courseId: number, memberId: number, payment: Payment): Promise<Payment> {
    return await lastValueFrom(this.http.post<Payment>(
      `${environment.apiUrl}/courses/${courseId}/regmembers/${memberId}/payments`,
      payment
    ));
  }

  async updatePayment(courseId: number, memberId: number, paymentId: number, payment: Partial<Payment>): Promise<Payment> {
    return await lastValueFrom(this.http.put<Payment>(
      `${environment.apiUrl}/courses/${courseId}/regmembers/${memberId}/payments/${paymentId}`,
      payment
    ));
  }

}
